<template>
  <v-card>
    <v-card-title>
      Link Bot
    </v-card-title>
    <v-card-text>
      <div class="text-subtitle-1">
        Create code to use APIs to interact with BOT.
      </div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">
              BOT
            </th>
            <th class="text-left">
              Status
            </th>
            <th class="text-center">
              Action
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="item in linkedBots"
              :key="item.id"
          >
            <td class="text-left">
              <v-list-item class="px-0">
                <v-list-item-avatar color="primary" class="white--text font-weight-bold justify-center">
                  {{$helper.getImageName(item.bot_name) }}
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{item.bot_name}}</v-list-item-title>
                  <v-list-item-subtitle>{{item.bot_code}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </td>
            <td class="text-left">
              {{item.token ? 'Token exists' : 'Token not exists'}}
            </td>
            <td class="text-center">
              <v-btn depressed class="text-none" color="primary" @click="generateToken(item)">Create token</v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-divider/>
    <v-card-actions class="mx-2">
      <v-btn depressed class="text-none my-2" color="primary" @click="showLinkBotEditor = true">Add or Remove Bot</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {sync} from "vuex-pathify";

export default {
  name: "ApplicationLinkBot",
  computed: {
    showLinkBotEditor: sync('dialogs/showLinkBotEditor'),
    currentApp: sync('application/currentApp'),
    currentLinkBot: sync('application/currentLinkBot'),
    showTokenGenerator: sync('dialogs/showTokenGenerator'),
    linkedBots() {
      return this.currentApp['linked_bots']
    }
  },
  methods: {
    generateToken(linkBotItem) {
      this.currentLinkBot = linkBotItem;
      this.showTokenGenerator = true;
    },
    iconText(title) {
      const matches = title.match(/\b(\w)/g)

      return matches.join('')
    }
  }
}
</script>

<style scoped>

</style>
